import { selectShowKbSearchOnInboxEditor } from 'ducks/currentUser/selectors/preferences/selectShowKbSearchOnInboxEditor'
import { doUpdateUserPreferences } from 'ducks/currentUser/operations'
import { selectUsageForProductFeature } from 'ducks/billing/selectors/usage/selectUsageForProductFeature'
import { KB } from 'ducks/billing/productTypes'
import { FEATURE_KB_MAX_KBS } from 'ducks/billing/featureTypes'

export function doToggleShowKbSearchOnInboxEditor() {
  return (dispatch, getState) => {
    const state = getState()
    const showKbSearchOnInboxEditor = selectShowKbSearchOnInboxEditor(state)
    const currentKbs = selectUsageForProductFeature(
      state,
      KB,
      FEATURE_KB_MAX_KBS
    )
    if (currentKbs > 0) {
      return doUpdateUserPreferences({
        show_kb_search_on_inbox_editor: !showKbSearchOnInboxEditor,
      })(dispatch, getState)
    }
    return Promise.resolve(null)
  }
}
